import { render, staticRenderFns } from "./addBrandData.vue?vue&type=template&id=0a5e84f4"
import script from "./addBrandData.vue?vue&type=script&lang=js"
export * from "./addBrandData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports